import styled, { css } from 'styled-components';
import { ACurrencySize, type ACurrencyProps } from './ACurrency.types';
type StyleProps = Omit<ACurrencyProps, 'text'>;

const stylesBySize = ({ size = ACurrencySize.ExtraSmall }: StyleProps) => {
  return {
    Medium: css`
      font-size: 1rem;
    `,
    ExtraSmall: css`
      font-size: 0.75rem;
    `,
  }[size];
};

export const Wrapper = styled.span<StyleProps>`
  display: inline-block;
  font-family: var(--t-base-font-family);
  color: var(--t-brand-fg-color);
  font-weight: 700;
  line-height: 125%;
  ${stylesBySize}
`;
